import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from 'src/app/app.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { isArray } from 'underscore';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent {
  @Input() questions: any;
  @Input() clickedContent: any;
  @Input() questionCounter: any;
  @Output() onAllSubmit = new EventEmitter<any>();
  public currentQuestionId = 0;
  answers: any = [];
  isProcessing = false;
  constructor(private appService: AppService, private snackBar: MatSnackBar) {

  }

  ngOnChanges() {
    this.currentQuestionId = this.questionCounter;
    this.res = this.questionCounter;

    for (let i = 0; i < this.questions.length; i++) {
      const q = this.questions[i];
      q.notVisited = i >= this.currentQuestionId;

      // Reset all option checked states first
      if (q.questionOptions && Array.isArray(q.questionOptions)) {
        q.questionOptions.forEach((opt: any) => opt.checked = false);
      }

      // Mark as answered if there's a saved answer
      if (q.selectedAnswer != null) {
        q.answered = true;

        // Only restore from saved answer if we haven't already captured user's current answer
        if (this.answers[i] === undefined || this.answers[i] === null) {
          this.answers[i] = q.selectedAnswer;

          if (q.questionType === "CHECKBOX" || q.questionType === "Check Box") {
            if (typeof this.answers[i] === "string") {
              this.answers[i] = this.answers[i]
                .split(",")
                .map((v: any) => v.trim());
            }

            // Restore UI
            q.questionOptions.forEach((opt: any) => {
              opt.checked = Array.isArray(this.answers[i]) && this.answers[i].includes(opt.optionCode);
            });
          }
          else {
            // Radio/single select
            const option = q.questionOptions.find((opt: any) => opt.optionCode === q.selectedAnswer);
            if (option) option.checked = true;
          }
        } else {
          // If we already have an answer (user has made changes), just update the UI based on current answer
          if (q.questionType === "CHECKBOX" || q.questionType === "Check Box") {
            if (Array.isArray(this.answers[i])) {
              // Update UI based on current answer array
              this.answers[i].forEach((value: any) => {
                const option = q.questionOptions.find((opt: any) => opt.optionCode === value);
                if (option) option.checked = true;
              });
            }
          } else {
            const option = q.questionOptions.find((opt: any) => opt.optionCode === this.answers[i]);
            if (option) option.checked = true;
          }
        }
      } else {
        q.answered = false;
        // Only initialize if not already set
        if (this.answers[i] === undefined) {
          this.answers[i] = undefined;
        }
      }
    }

    // Ensure current question is marked as visited
    if (this.questions[this.currentQuestionId]) {
      this.questions[this.currentQuestionId].notVisited = false;
    }
  }

  counter = -1;
  public onAnswer(questionCounter: any, questionId: number, data: any) {
    const question = this.questions.find((q: any) => q.questionId === questionId);
    if (!question) return;

    const option = question.questionOptions.find((opt: any) => opt.optionCode === data.value);
    if (!option) return;

    if (data.type === "RADIO" || data.type === "Radio Button") {
      this.answers[questionCounter] = data.value;
      // Uncheck all other options
      question.questionOptions.forEach((opt: any) => opt.checked = false);
      option.checked = true;
    } else if (data.type === "CHECKBOX" || data.type === "Check Box") {
      option.checked = data.checked; // reflect actual checkbox state

      // Initialize the answer array if it doesn't exist
      if (!this.answers[questionCounter] || !Array.isArray(this.answers[questionCounter])) {
        this.answers[questionCounter] = [];
      }

      if (data.checked) {
        if (!this.answers[questionCounter].includes(data.value)) {
          this.answers[questionCounter].push(data.value);
        }
      } else {
        const index = this.answers[questionCounter].indexOf(data.value);
        if (index > -1) {
          this.answers[questionCounter].splice(index, 1);
        }
      }
    }

    // Mark question as answered if any answer exists
    question.isAnswered = this.answers[questionCounter] != null &&
      (Array.isArray(this.answers[questionCounter])
        ? this.answers[questionCounter].length > 0
        : this.answers[questionCounter] !== '');

    this.counter = questionCounter;
  }

  public next() {
    this.choose();
    this.questions[this.currentQuestionId + 1].notVisited = false;
    if (this.answers[this.currentQuestionId] != null) {
      this.questions[this.currentQuestionId].answered = true;
    }
    this.currentQuestionId++;
  }

  public prev() {
    this.currentQuestionId--;
  }
  res = 0;

  public verify() {
    let correctCount = 0;

    this.questions.forEach((q: any, i: number) => {
      let correctAnswer = q.answerId;
      let userAnswer = this.answers[i];

      if (correctAnswer && userAnswer) {
        // Normalize both answers (split, trim, sort, join)
        const correctArray = correctAnswer.split(',').map((v: string) => v.trim()).sort();
        const userArray = userAnswer.split(',').map((v: string) => v.trim()).sort();

        // Compare arrays by stringified value
        if (JSON.stringify(correctArray) === JSON.stringify(userArray)) {
          correctCount++;
        }
      }
    });

    alert(`Your result is: ${correctCount}/${this.questions.length}`);
  }


  public choose() {
    //   if(this.questions[this.currentQuestionId].questionType == "Check Box" || this.questions[this.currentQuestionId].questionType == "CHECKBOX"){

    // // Sort alphabetically or by optionCode order before saving
    // const currentAnswer = this.answers[this.currentQuestionId];
    //   if (Array.isArray(currentAnswer)) {
    //     this.answers[this.currentQuestionId] = currentAnswer
    //       .map((ans: string) => ans.trim())
    //       .sort()
    //       .join(",");
    //   }

    //   }
    if (!Number.isNaN(this.answers[this.currentQuestionId])) {
      let dataSave: any = {};
      dataSave.userTrainingId = this.questions[this.currentQuestionId]['userTrainingId'];
      dataSave.contentId = this.questions[this.currentQuestionId]['contentId'];
      dataSave.questionId = this.questions[this.currentQuestionId]['questionId'];
      let q = this.questions[this.currentQuestionId];
      let ans = this.answers[this.currentQuestionId];

      if (q.questionType === "CHECKBOX" || q.questionType === "Check Box") {
        if (Array.isArray(ans)) {
          // Sort alphabetically before sending
          ans = ans.map((a: string) => a.trim()).sort();
          this.answers[this.currentQuestionId] = ans;
          dataSave.answer = ans.join(",");
        } else {
          dataSave.answer = ans;
        }
      } else {
        dataSave.answer = ans;
      }
      this.appService.trainingAssessmentAction(dataSave).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = false;
        } else {
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
    }
  }


  submitAllAnswers() {
    if (this.questions[this.currentQuestionId].questionType == "Check Box" || this.questions[this.currentQuestionId].questionType == "CHECKBOX") {
      if (isArray(this.answers[this.currentQuestionId])) {
        this.answers[this.currentQuestionId] = this.answers[this.currentQuestionId]
          .map((ans: string) => ans.trim())
          .sort()
          .join(",");
      }

    }
    if (!Number.isNaN(this.answers[this.currentQuestionId])) {
      let dataSave: any = {};
      dataSave.userTrainingId = this.questions[this.currentQuestionId]['userTrainingId'];
      dataSave.contentId = this.questions[this.currentQuestionId]['contentId'];
      dataSave.questionId = this.questions[this.currentQuestionId]['questionId'];
      const q = this.questions[this.currentQuestionId];
      let ans = this.answers[this.currentQuestionId];


      if (q.questionType === "CHECKBOX" || q.questionType === "Check Box") {
        if (Array.isArray(ans)) {
          // Sort before final submit
          ans = ans.map((a: string) => a.trim()).sort();
          this.answers[this.currentQuestionId] = ans;
          dataSave.answer = ans.join(",");
        } else {
          dataSave.answer = ans;
        }
      } else {
        dataSave.answer = ans;
      }
      this.appService.trainingAssessmentAction(dataSave).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = false;
        } else {
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
        this.onAllSubmit.emit(this.answers);

      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
    }
  }
}
